<template>
	<template v-if="errors.message">
		<div class="alert alert-warning">
			{{ $t(errors.message) }}
		</div>
	</template>

	<template v-if="saved">
		<div class="alert alert-success">Na podany adres e-mail wysłaliśmy link służący do aktywacji konta</div>
	</template>

	<App.Form @submit="register">
		<App.Input
			v-model="form.email"
			:error="errors.email"
		>
			E-mail
		</App.Input>

		<App.Input
			v-model="form.password"
			:type="'password'"
			:error="errors.password"
		>
			Hasło
		</App.Input>

		<App.Input
			v-model="form.password_again"
			:type="'password'"
			:error="errors.password_again"
		>
			Powtórz hasło
		</App.Input>

		<App.Input :type="'checkbox'" v-model="form.rule_1" :error="errors.rule_1">
			Oświadczam, że zapoznałem się z
			<a href="/pdf/privacy_policy_pl.pdf" download v-tooltip="'Pobierz politykę prywatności'">polityką prywatności</a>
			i akceptuję jej treść.
		</App.Input>

		<App.Input :type="'checkbox'" v-model="form.rule_2" :error="errors.rule_2">
			Wyrażam zgodę na wykorzystywanie automatycznych systemów wywołujących dla celów marketingu
			bezpośredniego usług i towarów oferowanych przez OFF-SITE sp. z o.o. oraz podmiotów zainteresowanych
			marketingiem własnych towarów lub usług.
		</App.Input>

		<App.Input :type="'checkbox'" v-model="form.rule_3" :error="errors.rule_3">
			Wyrażam zgodę na przesyłanie mi informacji handlowych za pomocą środków komunikacji elektronicznej, w
			tym w szczególności poczty elektronicznej, dotyczących marketingu bezpośredniego usług i towarów
			oferowanych przez OFF-SITE sp. z o.o. oraz podmiotów zainteresowanych marketingiem własnych towarów lub
			usług.
		</App.Input>

		<span class="hr m-b-5"></span>

		<App.Input
			v-model="form.is_client"
			:type="'checkbox'"
			@click.prevent="toggleUserRole('user')"
		>
		Zaznacz to pole, jeśli chcesz zarejestrować się jako <b>klient</b> - masz swoje projekty i potrzebujesz wsparcia w zakresie link buildingu/pozycjonowania.
		</App.Input>

		<App.Input
			v-model="form.is_publisher"
			:type="'checkbox'"
			@click.prevent="toggleUserRole('publisher')"
		>
			Zaznacz to pole, jeśli chcesz zarejestrować się jako <b>wydawca</b> - masz swoje portale, na których akceptujesz publikację artykułów sponsorowanych.
		</App.Input>

		<div class="flex flex-space-end">
			<App.Button :loading="loadings.register">
				Zarejestruj się
			</App.Button>
		</div>
	</App.Form>
</template>

<script setup>
	import * as App from './../components'
	import { useStore } from 'vuex'
	import { ref, getCurrentInstance } from 'vue'

	const store = useStore()
	const context = getCurrentInstance()

	const form = ref({
		is_publisher: false,
		is_client: true
	})
	let saved = ref(false)

	const register = () => {
		store.dispatch('register', {
			payload: form,
			context: context,
			loading: 'register'
		}).then(() => {
			saved.value = true
		}).finally(() => {
			window.scrollTo({ top: 0, behavior: 'smooth' })
		})
	}

	const toggleUserRole = (role) => {
		if(role == 'user') {
			form.value.is_client = true
			form.value.is_publisher = false
			return
		}

		form.value.is_client = false
		form.value.is_publisher = true
	}
</script>
